/*
    giftera: fișier Ella readus din sursă (șters la curățenie, pasul 8). Mecanismul e neschimbat: clasa
    „newsletter-show” pe <body>, cookie-ul „newsletter-popup”, întârzierea (data-delay) și expirarea (data-expire).
    Ce e adăugat e marcat cu „giftera:” și stă în metodele cu prefixul gf: deschiderea amânată cât e deschis
    altceva, focusul (intră în pop-up, rămâne în el, se întoarce la închidere), Esc, înălțimea vizibilă pe telefon.
*/
class NewsletterPopup extends HTMLElement {
    constructor() {
        super();

        this.popup = this;
        this.timeToShow = parseInt(this.popup.getAttribute('data-delay'));
        this.expiresDate = this.popup.getAttribute('data-expire');

        // giftera: după o abonare eșuată din pop-up (semnalul gfNewsletterRetry îl pune snippetul, care șterge și
        // cookie-ul) pop-up-ul revine imediat, cu adresa completată și mesajul de eroare sub câmp
        this.gfRetry = window.gfNewsletterRetry === true;
        if (this.gfRetry) this.timeToShow = 0;

        if (this.getCookie('newsletter-popup') === ''){
            var popup = this.popup;

            // giftera: deschiderea trece prin gfOpen() (în Ella: clasele puse direct pe <body>, aici și la +700ms)
            setTimeout(() => {
                this.gfOpen();
            }, this.timeToShow);
        } else {
            // this.deleteCookie('newsletter-popup');
        }

        document.body.addEventListener('click', this.onBodyClickEvent.bind(this));

        this.querySelector('[data-close-newsletter-popup]').addEventListener(
            'click',
            this.setClosePopup.bind(this)
        );

        this.querySelector('#ContactPopup').addEventListener(
            'submit',
            this.setClosePopup.bind(this)
        );

        // giftera: Esc închide, Tab rămâne în pop-up; pe telefon pop-up-ul urmărește zona vizibilă (tastatura)
        document.addEventListener('keydown', this.gfOnKeydown.bind(this));
        this.gfOnViewport = this.gfOnViewport.bind(this);
    }

    setCookie(cname, cvalue, exdays) {
        const d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        const expires = 'expires=' + d.toUTCString();
        document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
    }

    getCookie(cname) {
        const name = cname + '=';
        const ca = document.cookie.split(';');

        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }

        return '';
    }

    deleteCookie(name) {
        document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    }

    setClosePopup() {
        // giftera: reținem dacă pop-up-ul era deschis, ca focusul să fie mutat doar atunci
        const gfWasOpen = document.body.classList.contains('newsletter-show');

        this.setCookie('newsletter-popup', 'closed', this.expiresDate);
        document.body.classList.remove('newsletter-show');
        setTimeout(() => {
            document.body.classList.remove('show-newsletter-image');
        }, 700)

        if (gfWasOpen) this.gfAfterClose();
    }

    onBodyClickEvent(event){
        if ((!this.contains(event.target)) && ($(event.target).closest('[data-open-newsletter-popup]').length === 0) && document.querySelector('body').classList.contains('newsletter-show')){
            this.setClosePopup();
        }
    }

    // giftera: deschide pop-up-ul; dacă între timp a fost închis în alt tab nu mai apare, iar cât e deschis alt
    // sertar / dialog, fereastra de Chat, fereastra de cookie-uri sau scrii într-un câmp, mai așteaptă (nu ia focusul din mâna omului)
    gfOpen() {
        if (this.getCookie('newsletter-popup') !== '') return;

        if (this.gfBusy()) {
            setTimeout(() => {
                this.gfOpen();
            }, 3000);
            return;
        }

        this.gfLastFocus = document.activeElement;
        this.gfOnViewport();
        if (window.visualViewport) {
            window.visualViewport.addEventListener('resize', this.gfOnViewport);
            window.visualViewport.addEventListener('scroll', this.gfOnViewport);
        }

        document.body.classList.add('newsletter-show');
        setTimeout(() => {
            document.body.classList.add('show-newsletter-image');
        }, 700);

        // focusul intră în pop-up (pe dialog, nu pe câmp: pe telefon nu deschide tastatura), fără să deruleze pagina
        this.gfFocusSelf(0);
    }

    // giftera: până pornește tranziția (sau până se încarcă component-newsletter.css) pop-up-ul e visibility:hidden
    // și nu poate primi focus; încercăm din 100 în 100ms, cel mult 3 secunde
    gfFocusSelf(tries) {
        if (!document.body.classList.contains('newsletter-show')) return;

        if (window.getComputedStyle(this).visibility === 'visible') {
            // la reîncercare focusul merge în câmp: mesajul de eroare e legat de el prin aria-describedby
            const target = (this.gfRetry && this.querySelector('#NewsletterForm--Popup')) || this;

            target.focus({ preventScroll: true });
            return;
        }

        if (tries < 30) {
            setTimeout(() => {
                this.gfFocusSelf(tries + 1);
            }, 100);
        }
    }

    // giftera: e deschis altceva peste pagină sau omul scrie într-un câmp
    gfBusy() {
        const active = document.activeElement;

        if (active && active.matches('input, textarea, select, [contenteditable=""], [contenteditable="true"]')) return true;
        if (document.querySelector('dialog[open]')) return true;
        // giftera: fereastra de Chat (Shopify Inbox) stă peste pop-up și focusul e în shadow DOM-ul ei, nu într-un câmp
        // al paginii; cât e deschisă (atributul open), pop-up-ul așteaptă
        if (document.querySelector('shopify-chat[open]')) return true;
        if (document.body.classList.contains('gf-menu-open')) return true;

        // fereastra Shopify de consimțământ pentru cookie-uri, cât nu a primit răspuns; după răspuns, încă 20 s
        // (altfel pop-up-ul venea la 0,1–2 s după „Refuzare”, a doua fereastră peste produs)
        const consent = document.getElementById('shopify-pc__banner');

        if (consent && consent.getClientRects().length > 0) {
            this.gfConsentAt = performance.now();
            return true;
        }
        if (this.gfConsentAt && performance.now() - this.gfConsentAt < 20000) return true;

        // pe pagina de produs pop-up-ul nu întrerupe alegerea: abia după 45 s pe pagină și după ce omul
        // a derulat cel puțin până la jumătatea paginii (pe telefon aici aterizează aproape toate vizitele din reclame)
        if (document.body.classList.contains('template-product') && !this.gfRetry) {
            if (performance.now() < 45000) return true;
            const doc = document.documentElement;
            if (window.scrollY + window.innerHeight < doc.scrollHeight * 0.5) return true;
        }

        const overlay = document.querySelector('.background-overlay');

        return !!overlay && window.getComputedStyle(overlay).pointerEvents !== 'none';
    }

    // giftera: după închidere, focusul se întoarce unde era (fără derulare)
    gfAfterClose() {
        if (window.visualViewport) {
            window.visualViewport.removeEventListener('resize', this.gfOnViewport);
            window.visualViewport.removeEventListener('scroll', this.gfOnViewport);
        }

        const last = this.gfLastFocus;
        this.gfLastFocus = null;

        if (!this.contains(document.activeElement) && document.activeElement !== this) return;

        if (last && last !== document.body && document.contains(last) && typeof last.focus === 'function') {
            last.focus({ preventScroll: true });
        } else {
            document.activeElement.blur();
        }
    }

    // giftera: Esc închide pop-up-ul; Tab și Shift+Tab rămân între elementele lui
    gfOnKeydown(event) {
        if (!document.body.classList.contains('newsletter-show')) return;

        if (event.key === 'Escape' || event.key === 'Esc') {
            event.preventDefault();
            this.setClosePopup();
            return;
        }

        if (event.key !== 'Tab') return;

        const items = Array.from(this.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled]), select, textarea')).filter((item) => item.getClientRects().length > 0);

        if (items.length === 0) {
            event.preventDefault();
            return;
        }

        const first = items[0];
        const last = items[items.length - 1];
        const active = document.activeElement;
        const inside = this.contains(active) && active !== this;

        if (event.shiftKey && (!inside || active === first)) {
            event.preventDefault();
            last.focus();
        } else if (!event.shiftKey && (!inside || active === last)) {
            event.preventDefault();
            first.focus();
        }
    }

    // giftera: înălțimea și poziția zonei vizibile (se micșorează când apare tastatura pe telefon); le citește
    // assets/giftera-popup.css prin --gf-vv-h și --gf-vv-top, ca pop-up-ul să rămână întreg în ecran
    gfOnViewport() {
        const viewport = window.visualViewport;

        if (!viewport) return;

        this.style.setProperty('--gf-vv-h', Math.round(viewport.height) + 'px');
        this.style.setProperty('--gf-vv-top', Math.round(viewport.offsetTop) + 'px');
    }
}

customElements.define('newsletter-popup', NewsletterPopup);

class NewsletterMessagePopup extends HTMLElement {
    constructor() {
        super();

        this.querySelector('[data-close-newsletter-message-popup]').addEventListener(
            'click',
            this.close.bind(this)
        );

        document.body.addEventListener('click', this.onBodyClickEvent.bind(this));

        // giftera: Esc închide și fereastra cu mesajul de după abonare
        document.addEventListener('keydown', (event) => {
            if ((event.key === 'Escape' || event.key === 'Esc') && document.body.classList.contains('newsletter-message-show')) {
                this.close();
            }
        });
    }

    close(){
        document.body.classList.remove('newsletter-message-show');
    }

    // giftera: chemată din scripturile din snippet după ce apare mesajul; focusul trece pe butonul de închidere
    // când fereastra devine vizibilă (component-newsletter.css se încarcă târziu); cel mult 3 secunde
    gfFocusClose(tries = 0) {
        if (!document.body.classList.contains('newsletter-message-show')) return;

        if (window.getComputedStyle(this).visibility === 'visible') {
            this.querySelector('[data-close-newsletter-message-popup]').focus({ preventScroll: true });
            return;
        }

        if (tries < 30) {
            setTimeout(() => {
                this.gfFocusClose(tries + 1);
            }, 100);
        }
    }

    onBodyClickEvent(event){
        if (!this.contains(event.target)){
            this.close();
        }
    }
}

customElements.define('newsletter-message-popup', NewsletterMessagePopup);
